module.exports = __webpack_public_path__ + "2ef1d8695266281aa08b6dbe1bbcd393.svg";